/* eslint-disable no-nested-ternary */
import moment from 'moment-timezone';
import {
  isOpenNow,
  isOpenSoon,
  getTodayHours,
  isAlwaysOpen,
  reservationsDisabledNow,
  isInGroup,
} from './location';
import { isEmptyObject, safeGet } from './object';
import { isEmptyArray } from '../../core/util/array';
import { isReservationsRemainingToday } from '../location/slots';
import DateTime, { HOUR_MINUTE_PERIOD } from '../../components/DateTime';
import { pluralize } from './string';
import { isTelemedLocation } from './location';
import { OPEN_24_HOURS, ORIGIN_BOOKING_WIDGET } from '../../constants';
import { TOTAL_ACCESS_GROUP_ID } from '../../config/locations';

const OPEN = 'Open now';
const SOON = 'Opening soon';
const OPEN_WALK_IN_ONLY = 'Open now - Walk in only';
const CLOSED = 'Closed';
const BOOK_SOON = 'Beat the rush, book online.';
const BOOK_TODAY = 'Book for later today!';
const BOOK_TOMORROW = 'Book for tomorrow!';
export const TODAY = 'Today';
export const TOMORROW = 'Tomorrow';
const CLOSED_FOR_LUNCH = 'Closed for lunch daily from 1pm to 2pm';

const nowMap = {
  [OPEN_24_HOURS]: s => s.alwaysOpen,
  [OPEN]: s => s.open,
  [OPEN_WALK_IN_ONLY]: s => s.openNowWalkInOnly,
  [SOON]: s => s.soon,
  [CLOSED]: s => s.closed,
};

const peopleInLineText = l => `Currently ${l} ${pluralize(l, 'person')} in line`;

const getOpenOrClosedText = location =>
  isAlwaysOpen(location)
    ? OPEN_24_HOURS
    : !isTelemedLocation(location) &&
      isOpenNow(location) &&
      (reservationsDisabledNow(location) || !isReservationsRemainingToday(location))
    ? OPEN_WALK_IN_ONLY
    : isOpenNow(location)
    ? OPEN
    : isOpenSoon(location)
    ? SOON
    : CLOSED;

const isBeforeOpen = location => {
  const tz = location.timeZone;
  const curTime = moment.tz(tz);
  const openTime = moment.tz(getTodayHours(location).fromTime, 'HH:mm', tz);

  return curTime.isBetween(moment(openTime).startOf('day'), openTime);
};

const getFlavorText = (openStatus, location, waitListCount) => {
  switch (openStatus) {
    case OPEN:
    case OPEN_WALK_IN_ONLY:
    case OPEN_24_HOURS:
      if (isInGroup(location, TOTAL_ACCESS_GROUP_ID)) return '';
      return peopleInLineText(waitListCount);
    case CLOSED:
      return isBeforeOpen(location) ? BOOK_TODAY : BOOK_TOMORROW;
    default:
    case SOON:
      return BOOK_SOON;
  }
};

const getFirstDailySlot = (day, allSlots) => {
  let slots = null;
  if (day === TODAY) {
    slots = allSlots.today;
  }

  if (day === TOMORROW) {
    slots = allSlots.tomorrow;
  }

  if (isEmptyArray(slots)) {
    return null;
  }

  return slots[0];
};

const getOptions = (allSlots, location) => {
  const options = [];
  if (isEmptyObject(allSlots)) return [];

  const todayFirstSlot = getFirstDailySlot(TODAY, allSlots);
  if (!isEmptyObject(todayFirstSlot)) {
    options.push({
      value: todayFirstSlot,
      label: TODAY,
      busy: todayFirstSlot.isBusy,
    });
    allSlots.today.forEach(slot => {
      if (slot.availability !== 0) {
        const aptTime = DateTime.format(slot.appointmentDate, location.timeZone)(
          HOUR_MINUTE_PERIOD
        );
        let label = aptTime;
        if (slot.isBusy) {
          label = `${aptTime} (busy time)`;
        }

        options.push({ value: slot, label, busy: slot.isBusy });
      }
    });
  }

  const tomorrowFirstSlot = getFirstDailySlot(TOMORROW, allSlots);
  if (!isEmptyObject(tomorrowFirstSlot)) {
    options.push({
      value: tomorrowFirstSlot,
      label: TOMORROW,
      busy: tomorrowFirstSlot.isBusy,
    });
    allSlots.tomorrow.forEach(slot => {
      if (slot.availability !== 0) {
        const aptTime = DateTime.format(slot.appointmentDate, location.timeZone)(
          HOUR_MINUTE_PERIOD
        );
        let label = aptTime;
        if (slot.isBusy) {
          label = `${aptTime} (busy time)`;
        }

        options.push({ value: slot, label, busy: slot.isBusy });
      }
    });
  }

  return options;
};

const isBookingWidgetBookingFlow = newBooking =>
  safeGet(newBooking)('booking.origin') === ORIGIN_BOOKING_WIDGET;

export {
  OPEN,
  OPEN_WALK_IN_ONLY,
  SOON,
  CLOSED,
  CLOSED_FOR_LUNCH,
  BOOK_SOON,
  BOOK_TODAY,
  BOOK_TOMORROW,
  nowMap,
  getFlavorText,
  isBeforeOpen,
  isBookingWidgetBookingFlow,
  getOpenOrClosedText,
  getOptions,
};
